import tools from '@/sui/data/sheets/edit/tools'
import catheter from '@/sui/data/sheets/edit/catheter'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'

const blc = tools.equals(fields.isColIlcBlcSep, 4)
const sep = tools.equals(fields.present, 1)
const select = {
  kt: {
    v1: tools.equals2(fields.catheterType, 1, 2),
    v2: tools.equals2(fields.catheterType, 'C1', 'C3'),
    v3: tools.match(fields.catheterType, /^C[134]$/)
  },
  alive: tools.equals(fields.dead, 2),
  colIlcBlcSep: tools.inList(fields.isColIlcBlcSep, [2, 3, 4, 5]),
  colIlcBlc: tools.inList(fields.isColIlcBlcSep, [2, 3, 4]),
  blc,
  sep,
  sepC2C4: tools.allTrue(sep, tools.equals2(fields.entrance, 'C2', 'C4')),
  sepC2C8C9C12: tools.allTrue(sep, tools.match(fields.entrance, /^C([289]|12)$/)),
  dd5: tools.allTrue(blc, tools.equals(fields.divDiag, 5))
}

const colIlcBlcSep = tools.cfg.date(
  fields.colIlcBlcSep, 'ILC / BLC / SEPSIS', { sel: select.colIlcBlcSep }
)

const origin = (function () {
  const f = fields.origin
  const t = 'Provenance'
  return {
    v1: tools.cfg.list(
      f, t, go.fields2019.neoOrigin, {
        ph: '«d» pour DOM, «nn» pour Néonatalogie...',
        tt: `Taper la ou les premières lettres du code : ${tools.key('d')} pour
DOM, ${tools.key('nn')} pour Néonatalogie, etc.`,
        ms: true
      }
    ),
    v2: tools.cfg.list(f, t, go.fields.neoOrigin)
  }
})()

const future = (function () {
  const f = fields.future
  const t = 'Devenir'

  return {
    v1: tools.cfg.list(
      f, t, go.fields2019.neoFuture, {
        ms: true,
        tt: `Taper la ou les premières lettres du code : ${tools.key('d')}
pour DOM, ${tools.key('e')} pour ETAB, etc.`,
        ph: '«d» pour DOM, «e» pour ETAB...',
        sel: select.alive
      }
    ),
    v2: tools.cfg.list(f, t, go.fields.neoFuture, { sel: select.alive })
  }
})()

const catheterType = (function () {
  function build (f, p) {
    return tools.cfg.list(
      fields.catheterType, 'Type de cathéter', f, { pop: tools.not(p) }
    )
  }
  return {
    v1: build(go.fields2019.neoKTType, select.kt.v1),
    v2: build(go.fields2025.neoKTType, select.kt.v2),
    v3: build(go.fields.neoKTType, select.kt.v3)
  }
})()

const material = tools.cfg.list(
  fields.material, 'Matériau', go.fields.neoMaterial
)

const insertionSite = (function () {
  function build (v) {
    return tools.cfg.list(fields.insertionSite, 'Site de pose', v)
  }

  return {
    v1: build(go.fields2019.neoInsertionSite),
    v2: build(go.fields2021.neoInsertionSite),
    v3: build(go.fields.neoInsertionSite)
  }
})()

const lipids = tools.cfg.list(
  fields.lipids, 'Lipides', go.fields.yesNoUnknown
)

const removalReason = tools.cfg.list(
  fields.removalReason, 'Motif du retrait',
  go.fields.neoRemovalReason, { sel: catheter.select.ktr }
)

const isColIlcBlcSep = tools.cfg.list(
  fields.isColIlcBlcSep, 'COL / ILC / BLC / SEPSIS', go.fields.neoColIlcBlcSep,
  { ph: 'Taper le code ou le nom...' }
)

const colIlcBlcSepOrigin = (function () {
  function build (v) {
    return tools.cfg.list(
      fields.colIlcBlcSepOrigin, 'Origine ILC / BLC / SEPSIS', v,
      { sel: select.colIlcBlcSep }
    )
  }

  return {
    v1: build(go.fields2019.neoInfOrigin),
    v2: build(go.fields.bactOriginNoEhpad)
  }
})()

const sepOrigin = (function () {
  function build (v) {
    return tools.cfg.list(
      fields.origin, 'Origine du sepsis', v, { sel: select.sep }
    )
  }
  return {
    v1: build(go.fields2019.neoInfOrigin),
    v2: build(go.fields.bactOriginNoEhpad)
  }
})()

const sepEntrance = (function () {
  function build (v) {
    return tools.cfg.list(
      fields.entrance, `Porte d'entrée`, v, { sel: select.sep }
    )
  }
  return {
    v1: build(go.fields2019.sepEntrance),
    v2: build(go.fields2020.sepEntrance),
    v3: build(go.fields2021.sepEntrance),
    v4: build(go.fields2025.sepEntrance),
    v5: build(go.fields.sepEntrance)
  }
})()

const sepPresent = tools.cfg.list(
  fields.present, 'Sepsis', go.fields.yesNoUnknown, {
    def: 1,
    pop: tools.not(select.sep)
  }
)

const lipidsDiagnosis = (function () {
  const list = tools.cfg.list(
    fields.lipidsDiagnosis, 'Lipides au diagnostic', go.fields.yesNoUnknown
  )

  return {
    v1: list,
    v2: tools.select(list, select.colIlcBlcSep)
  }
})()

const blcCriteria = (function () {
  function build (f, v) {
    return tools.cfg.list(
      f, 'Critère BLC', v, {
        sel: select.blc,
        ms: true,
        tt: 'Taper directement le code du critére.',
        ph: 'Taper le code...'
      }
    )
  }

  return {
    v1: build(fields.blcCriteria, go.fields2020.neoDivDiag),
    v2: build(fields.divDiag, go.fields.divDiag)
  }
})()

export default {
  colIlcBlcSep,
  select,

  origin,
  future,
  catheterType,
  material,
  insertionSite,
  lipids,
  removalReason,
  isColIlcBlcSep,
  colIlcBlcSepOrigin,
  sepOrigin,
  sepEntrance,
  sepPresent,
  lipidsDiagnosis,
  blcCriteria
}
